const prefix = '/standards';

export const STANDARDS_LIST_TAG = `${prefix}`;
export const STANDARDS_DETAILS_TAG = `${prefix}/id`;
